import * as R from 'ramda';
import styled from 'styled-components';
import { space, width } from 'styled-system';
// mui
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import { styled as styledMui } from '@mui/material';
// utilities
import { isTrue } from '../../utilities';
//////////////////////////////////////////////////

const getErrorColor = theme => `${theme.palette.error.main} !important`;

const renderBorderColor = props => {
  const {
    theme,
    error,
    touched,
    additionalBorderColor,
    useAdditionalBorderColor,
  } = props;

  if (R.and(error, touched)) return getErrorColor(theme);

  if (isTrue(useAdditionalBorderColor)) return additionalBorderColor;

  return theme.colors.lime;
};

const setDefaultErrorStyles = ({ error, theme }) => ({
  '.MuiInputLabel-root': { color: error && getErrorColor(theme) },
  '.MuiFormHelperText-root': { fontSize: 13, letterSpacing: 0, color: error && getErrorColor(theme) },
  '.MuiOutlinedInput-notchedOutline': {
    borderWidth: error && '1.5px',
    borderColor: error && getErrorColor(theme),
  },
});

const StyledTextField = styledMui(TextField)(({ theme, error }) => ({
  ...setDefaultErrorStyles({ error, theme }),
}));

const StyledFormControl = styled(FormControl)(({ theme, error }) => ({
  ...setDefaultErrorStyles({ error, theme }),
}));

const CleanWrapper = styled.div`
  top: 0;
  right: 15px;
  width: 23px;
  z-index: 14;
  height: 30px;
  padding: 7px 5px;
  position: absolute;
`;

const UploadWrapper = styled.label`
  ${space}
  ${width}

  height: 42px;
  padding: 6px 0;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  position: relative;
  border-radius: 4px;
  margin-bottom: 30px;
  text-overflow: ellipsis;

  display: ${({ display }) => display || 'block'};
  border: 2px dashed ${props => renderBorderColor(props)};
  background-color: ${({ theme }) => theme.background.default};

  & input[type=file] {
    display: none;
  }
  &:focus {
    box-shadow: 0 0 5px 0 rgba(206, 40, 40, 0.5);
  }
`;

export {
  CleanWrapper,
  UploadWrapper,
  StyledTextField,
  StyledFormControl,
  renderBorderColor,
  setDefaultErrorStyles,
};
